import * as React from 'react';

const Spacer = () => <div style={{ flexGrow: 1 }}>&nbsp;</div>;

export { Spacer };
